import { render, staticRenderFns } from "./customerArticles.vue?vue&type=template&id=1faf17a0&scoped=true&"
import script from "./customerArticles.vue?vue&type=script&lang=js&"
export * from "./customerArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faf17a0",
  null
  
)

export default component.exports